export default function imageLoader({
  src,
  width,
  quality,
}: {
  src: string
  width?: number
  quality?: number
}) {
  // For static export, return original src with optimizations
  const params = new URLSearchParams();
  
  if (width) params.set('w', width.toString());
  if (quality) params.set('q', quality.toString());
  
  // Add WebP format support if available
  const hasParams = params.toString();
  return hasParams ? `${src}?${hasParams}` : src;
}
